module.exports = __webpack_public_path__ + "img/tx-settings.5692b756.png";